// ligfrontend/src/components/common/AvatarSelector.jsx
import React, { useState } from "react";
import "./AvatarSelector.css";

const AVATAR_OPTIONS = [
  "/js/images/fox.png",
  "/js/images/bear.png",
  "/js/images/cat.png",
  "/js/images/dog.png",
  "/js/images/owl.png",
  "/js/images/mystery.png",
];

const AvatarSelector = ({ currentAvatar, onSelect, editable = false }) => {
  const [showSelector, setShowSelector] = useState(false);

  const handleSelect = (avatar) => {
    onSelect(avatar);
    setShowSelector(false);
  };

  return (
    <div className="avatar-selector">
      <div
        className={`avatar-display ${editable ? "editable" : ""}`}
        onClick={() => editable && setShowSelector(!showSelector)}
      >
        <img
          src={currentAvatar || "/js/images/mystery.png"}
          alt="Avatar"
          className="avatar-image"
        />
        {editable && (
          <div className="avatar-overlay">
            <span>Change</span>
          </div>
        )}
      </div>

      {showSelector && (
        <div className="avatar-options">
          <div className="avatar-grid">
            {AVATAR_OPTIONS.map((avatar) => (
              <div
                key={avatar}
                className={`avatar-option ${
                  currentAvatar === avatar ? "selected" : ""
                }`}
                onClick={() => handleSelect(avatar)}
              >
                <img src={avatar} alt="Avatar option" />
              </div>
            ))}
          </div>
          <button
            className="btn-close-selector"
            onClick={() => setShowSelector(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default AvatarSelector;
